import type { Banner } from '../../../domain/Banner'
import type { BannerDTO } from '../../../domain/BannerDTO'
import { ContentModelId } from '../../../../../types/ContentModelId'
import type { PartnerId } from '../../../../../types/PartnerId'

import { isAvailablePartner } from '../../../../../utils/filter-by-partner'
import { isNonNullableEntryDTO } from '../../../../../utils/non-nullable-entry-dto'

export const mapBannerFromApi = (dto: BannerDTO, partnerId?: PartnerId): Banner | undefined => {
  if (!(isNonNullableEntryDTO(dto) && isAvailablePartner(partnerId, dto.fields.partnerFilter))) {
    return undefined
  }

  const { contentName, description, desktopImage, isSmall, link, mobileImage, supplierName } = dto.fields

  return {
    contentName,
    contentType: ContentModelId.BANNER,
    description,
    desktopImage: desktopImage!.fields,
    isSmall,
    link,
    mobileImage: mobileImage!.fields,
    supplierName,
  }
}
